const DECORATIVE_FONTS_ID = 'aumhum-decorative-fonts'
const DECORATIVE_FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Cabin+Sketch:wght@400;700&family=Great+Vibes&family=Nothing+You+Could+Do&display=swap'

let decorativeFontsPromise

export function ensureDecorativeFontsLoaded() {
  if (typeof document === 'undefined') {
    return Promise.resolve()
  }

  if (document.getElementById(DECORATIVE_FONTS_ID)) {
    return Promise.resolve()
  }

  if (decorativeFontsPromise) {
    return decorativeFontsPromise
  }

  decorativeFontsPromise = new Promise((resolve) => {
    const link = document.createElement('link')
    link.id = DECORATIVE_FONTS_ID
    link.rel = 'stylesheet'
    link.href = DECORATIVE_FONTS_HREF
    link.onload = () => resolve()
    link.onerror = () => resolve()
    document.head.appendChild(link)
  })

  return decorativeFontsPromise
}
